<a href="#main" class="s__skip-link">Skip to main content</a>
<ds-header />
<main id="main" tabindex="-1" class="s__main">
  <router-outlet />
</main>
@defer (on immediate; hydrate on viewport) {
  <ds-footer />
}
